import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router-dom";
import RatingDisplay from "../Rating/Rating";
import "react-datepicker/dist/react-datepicker.css";
import { baseUrl } from "../../Environments/environment";
import axios from "axios";
import { motion } from "framer-motion";
import "./modal.css";
import google from "../../Assets/google.png";
import onelyk from "../../Assets/onelyk.png";
import yelp from "../../Assets/yelp.png";
import tripadvisor from "../../Assets/tripadvisor.png";
import booking from "../../Assets/booking.png";
import expedia from "../../Assets/expedia.png";
import agoda from "../../Assets/agoda.png";
import { ThreeDot } from "react-loading-indicators";
import PropertyRatingDisplay from "../Rating/propertyRating";
//import Logo from "../Logo/logo";
import onelykLogo from "../../Assets/onelyk.png";

const PropertyModal = () => {
  const navigate = useNavigate();
  const guestid = useParams();
  const guestSessionId = "";
  const propertyId = guestid.propertyId;
  const [guest, setGuest] = useState(null);
  const [property, setProperty] = useState(null);
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState(null);
  const [reviewFlow, setReviewFlow] = useState([]);
  const [initialRating, setInitialRating] = useState(0); // Track initial rating that triggered review
  const [showInternalReview, setShowInternalReview] = useState(false); // Controls whether to show rating form
  const [showThankYouMessage, setShowThankYouMessage] = useState(false); // Show thank you after internal review

  const [ratingLoading, setRatingLoading] = useState(false);
  const [pendingRating, setPendingRating] = useState(null);
  const [progressiveFill, setProgressiveFill] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

  // Helper function to check if internal review is completed
  const isInternalReviewCompleted = (reviewData = review) => {
    if (!reviewData) return false;

    // Check multiple indicators that internal review was completed:

    // 1. Check if any category ratings (other than overAllRating) exist
    const categoryRatings = [
      "roomRating",
      "serviceRating",
      "locationRating", // Hospitality
      "foodRating",
      "ambienceRating", // Restaurant
      "productQualityRating",
      "valueRating", // Retail
      "treatmentQualityRating",
      "cleanlinessRating",
      "staffProfessionalismRating", // Beauty/Spa
      "qualityRating",
      "responsivenessRating",
      "professionalismRating",
      "cleanupRating", // Home Services
      "knowledgeRating",
      "communicationRating",
      "resultsRating", // Professional Services
      "repairQualityRating",
      "customerServiceRating",
      "waitTimeRating", // Auto Services
      "doctorBehaviorRating",
      "waitingTimeRating",
      "facilityRating", // Medical
      "instructorRating",
      "facilityQualityRating",
      "programValueRating", // Education/Fitness
    ];
    const hasCategory = categoryRatings.some(
      (key) => reviewData[key] && reviewData[key] > 0,
    );

    // 2. Check if comments exist (user filled the internal form)
    const hasComments = reviewData.comments && reviewData.comments.length > 0;

    // 3. Check if tripType or travelWith exist (unique to internal review)
    const hasTripInfo = reviewData.tripType || reviewData.travelWith;

    // 4. Check if hotelDescription array exists
    const hasDescription =
      reviewData.hotelDescription && reviewData.hotelDescription.length > 0;

    // 5. Check if detailedFeedback exists
    const hasDetailedFeedback =
      reviewData.detailedFeedback &&
      ((typeof reviewData.detailedFeedback === "object" &&
        Object.keys(reviewData.detailedFeedback).length > 0) ||
        (typeof reviewData.detailedFeedback === "string" &&
          reviewData.detailedFeedback.length > 0));

    const isCompleted =
      hasCategory ||
      hasComments ||
      hasTripInfo ||
      hasDescription ||
      hasDetailedFeedback;

    return isCompleted;
  };

  // Progressive fill effect
  useEffect(() => {
    if (pendingRating && isAnimating) {
      setProgressiveFill(0);
      let current = 0;
      const interval = setInterval(() => {
        current++;
        setProgressiveFill(current);
        if (current >= pendingRating) {
          clearInterval(interval);
          setTimeout(() => {
            setPendingRating(null);
            setIsAnimating(false);
            handleRating(pendingRating);
          }, 350);
        }
      }, 80);
      return () => clearInterval(interval);
    }
  }, [pendingRating, isAnimating]);

  async function handleSubmiListingReview(lst) {
    try {
      if (lst?.url) {
        window.open(lst.url, "_blank", "noopener,noreferrer");
      }

      const updatedListing = review?.listing.map((element) =>
        element.network === lst.network
          ? {
              ...element,
              reviewGiven: true,
              overAllRating: pendingRating || review?.overAllRating,
            }
          : element,
      );
      const updatedReview = {
        ...review,
        overAllRating: pendingRating || review?.overAllRating,
        listing: updatedListing,
      };

      axios.post(`${baseUrl}/guestApi/property/${propertyId}/guest`, {
          ...updatedReview,
        })
        .then((res) => {
          if (res.status === 201) {
            const id = res.data?.result?.id;
            navigate(`/${id}`);
          }
        })
        .catch(console.error);

    } catch (error) {
      console.error("Error submitting listing review:", error);
    }
  }

  // Prevent body scroll while this page is mounted
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    if (!propertyId) return;

    const fetchData = async () => {
      try {
        setRatingLoading(true);

        // Fetch both review and workflow in parallel
        const [propertyRes, reviewRes, workflowRes] = await Promise.all([
          axios.get(`${baseUrl}/guestApi/property/${propertyId}`),
          axios.get(`${baseUrl}/guestApi/property/${propertyId}/defaultreview`),
          axios.get(`${baseUrl}/guestApi/property/${propertyId}/workflow`),
        ]);

        const fetchedGuest = {};
        const fetchedProperty = propertyRes.data.result;
        const fetchedReview = reviewRes.data.result.review;
        const fetchedWorkflow = workflowRes.data.result.reviewFlow;
        console.log(fetchedProperty);
        setGuest(fetchedGuest);
        setProperty(fetchedProperty);
        setReview(fetchedReview);
        setReviewFlow(fetchedWorkflow);
        localStorage.setItem("reviewFlow", JSON.stringify(fetchedWorkflow));

        // If internal review was completed, determine what rating to display
        if (fetchedReview.overAllRating > 0) {
          const isInternal = isInternalReviewCompleted(fetchedReview);

          if (isInternal) {
            // Internal review was completed
            // Check if backend provided initialRating
            if (fetchedReview.initialRating) {
              // Use the initialRating from backend
              setRating(fetchedReview.initialRating);
              setInitialRating(fetchedReview.initialRating);
            } else {
              // Fallback: if current rating is above threshold, user likely changed it
              const currentRatingAboveThreshold =
                fetchedReview.overAllRating >
                fetchedWorkflow.startLimitForReviewLink;

              if (currentRatingAboveThreshold) {
                // User changed rating to high value in internal form
                // Display threshold value as estimate of initial rating
                const displayRating =
                  fetchedWorkflow.startLimitForReviewLink || 3;
                setRating(displayRating);
                setInitialRating(displayRating);
              } else {
                // Rating is still low, display as is
                setRating(fetchedReview.overAllRating);
                setInitialRating(fetchedReview.overAllRating);
              }
            }
          } else {
            // No internal review, display actual rating
            setRating(fetchedReview.overAllRating);
          }

          const hasPendingReviews = fetchedReview?.listing?.some(
            (e) => !e.reviewGiven,
          );

          // Only show platform buttons if:
          // 1. No internal review was completed (or rating was high from start)
          // 2. Rating is above threshold
          // 3. There are pending platform reviews
          if (
            !isInternal &&
            hasPendingReviews &&
            fetchedWorkflow?.reviewsEnabled &&
            fetchedReview.overAllRating >
              fetchedWorkflow.startLimitForReviewLink
          ) {
            setIsBottomSheetOpen(true);
          }
        } else {
          setRating(0);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setRatingLoading(false);
      }
    };

    fetchData();
  }, [propertyId]);

  const handleRating = async (rate) => {
    if (!ratingLoading && reviewFlow) {
      setRating(rate);
      setInitialRating(rate);
      setReview((prev) => ({ ...prev, overAllRating: rate }));
      const hasPendingReviews = review?.listing?.some((e) => !e.reviewGiven);

      if (
        reviewFlow.reviewsEnabled &&
        rate > reviewFlow.startLimitForReviewLink
      ) {
        if (hasPendingReviews) {
          setIsBottomSheetOpen(true);
          const defaultListing = review?.listing?.find((lst) => lst.isDefault);
          if (defaultListing) {
            handleSubmiListingReview(defaultListing);
          } else if (review?.listing?.length === 1) {
            handleSubmiListingReview(review?.listing[0]);
          }
        }
      } else {
        // Show internal review form instead of navigating
        setShowInternalReview(true);
      }
    }
  };

  const handleReviewComplete = async () => {
    // Hide the internal review form
    setShowInternalReview(false);

    // Show thank you message (permanently, no auto-hide)
    setShowThankYouMessage(true);
  };

  const handleReviewCancel = () => {
    // Just hide the internal review form, don't show thank you message
    setShowInternalReview(false);
  };

  if (ratingLoading) {
    return (
      <div className="min-h-[100svh] grid place-items-center">
        <ThreeDot variant="brick-stack" color="#4f46e5" size="medium" />
      </div>
    );
  }

  const propertyName =
    property?.property?.name ||
    property?.name ||
    property?.propertyName ||
    property?.title ||
    "";

  return (
    <div className="fixed inset-0  flex flex-col">
      {/* Header: Logo + Property name (centered) */}
      <div className="relative w-full px-4 py-3 bg-white flex-shrink-0 border-b border-gray-100 shadow-sm">
        <div className="flex items-center max-w-2xl mx-auto">
          <img
            src={property?.property?.logoUrl}
            alt="Property logo"
            className="w-16 h-14 min-w-[4rem] flex-shrink-0 object-contain"
          />
          {propertyName ? (
            <motion.div
              className="absolute left-0 right-0 flex justify-center items-center pointer-events-none"
              initial={{ opacity: 0, y: -12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                ease: [0.22, 1, 0.36, 1],
                delay: 0.15,
              }}
            >
              <motion.h1
                className="text-lg sm:text-xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800 truncate max-w-[70%] text-center"
                initial={{ opacity: 0, letterSpacing: "0.2em" }}
                animate={{ opacity: 1, letterSpacing: "0.02em" }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                {propertyName}
              </motion.h1>
            </motion.div>
          ) : null}
        </div>
      </div>
      <div className="flex-1 overflow-hidden min-h-0">
        <div className="min-h-full">
          <div className="min-h-[100svh] grid place-items-center px-4 py-10 bg-white">
            {showInternalReview ? (
              <PropertyRatingDisplay
                guest={guest}
                propertyId={propertyId}
                property={property}
                review={review}
                initialRating={initialRating}
                onComplete={handleReviewComplete}
                onCancel={handleReviewCancel}
              />
            ) : (
              <motion.div
                className="w-full max-w-md flex flex-col items-center"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
              >
                {/* Rating heading - always shown */}
                <div className="text-base text-gray-700 text-center mb-2 font-medium">
                  Please Rate Your Experience
                </div>
                <motion.div
                  className="text-sm text-gray-500 text-center mb-1"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5, duration: 0.5 }}
                >
                  Choose 1-5 stars. 5 stars is excellent.
                </motion.div>
                <div
                  className="relative flex flex-row justify-center items-center gap-2 mb-3"
                  style={{ minHeight: 44 }}
                >
                  {[1, 2, 3, 4, 5].map((star) => {
                    let isFilled = star <= rating;
                    if (pendingRating && isAnimating) {
                      isFilled = star <= progressiveFill;
                    }
                    return (
                      <motion.svg
                        key={star}
                        onClick={() => {
                          if (
                            !isAnimating &&
                            !review?.listing?.some((e) => e.reviewGiven) &&
                            !isInternalReviewCompleted()
                          ) {
                            // start progressive animation for visual effect
                            setPendingRating(star);
                            setIsAnimating(true);
                          }
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        fill={isFilled ? "#4F46E5" : "none"}
                        viewBox="0 0 24 24"
                        stroke="#4F46E5"
                        className={`w-10 h-10 z-10 star-glow-hover${
                          isFilled ? " star-glow-theme" : ""
                        }${
                          review?.listing?.some((e) => e.reviewGiven) ||
                          isInternalReviewCompleted()
                            ? " cursor-not-allowed opacity-70"
                            : " cursor-pointer"
                        }`}
                        whileHover={
                          !isAnimating &&
                          rating === 0 &&
                          !review?.listing?.some((e) => e.reviewGiven) &&
                          !isInternalReviewCompleted()
                            ? {
                                scale: 1.22,
                                filter: "drop-shadow(0 0 12px #4F46E5)",
                              }
                            : false
                        }
                        whileTap={
                          !isAnimating &&
                          rating === 0 &&
                          !review?.listing?.some((e) => e.reviewGiven) &&
                          !isInternalReviewCompleted()
                            ? { scale: 1.35 }
                            : false
                        }
                        animate={
                          rating === 0 &&
                          !isAnimating &&
                          !review?.listing?.some((e) => e.reviewGiven) &&
                          !isInternalReviewCompleted()
                            ? {
                                scale: [1, 1.13, 1],
                                filter: isFilled
                                  ? "drop-shadow(0 0 16px #4F46E5)"
                                  : "",
                              }
                            : isFilled
                              ? { filter: "drop-shadow(0 0 16px #4F46E5)" }
                              : {}
                        }
                        transition={
                          rating === 0 && !isAnimating
                            ? {
                                repeat: Infinity,
                                duration: 1.1,
                                type: "tween",
                                ease: "easeInOut",
                              }
                            : { type: "spring", stiffness: 300, damping: 20 }
                        }
                        style={{
                          transition: "fill 0.2s, stroke 0.2s, filter 0.3s",
                        }}
                      >
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          strokeWidth="1.3"
                          d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.385 4.267a1 1 0 00.95.69h4.486c.969 0 1.371 1.24.588 1.81l-3.625 2.634a1 1 0 00-.364 1.118l1.385 4.267c.3.921-.755 1.688-1.54 1.118L12 17.011l-3.625 2.634c-.784.57-1.84-.197-1.54-1.118l1.385-4.267a1 1 0 00-.364-1.118L4.231 9.694c-.783-.57-.38-1.81.588-1.81h4.486a1 1 0 00.95-.69l1.385-4.267z"
                        />
                      </motion.svg>
                    );
                  })}
                </div>

                {/* Thank You Message - shown after review completion */}
                {showThankYouMessage && (
                  <div className="mx-4 px-4 sm:px-6 py-4 bg-green-50 border border-green-200 rounded-lg shadow-md max-w-md w-full mt-4">
                    <div className="flex items-center gap-2 sm:gap-3">
                      <div className="flex-shrink-0">
                        <svg
                          className="w-5 h-5 sm:w-6 sm:h-6 text-green-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                      <div className="flex-1">
                        <p className="text-xs sm:text-sm font-medium text-white-800">
                          Thanks for your feedback. Our team will review it
                          shortly.
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {isBottomSheetOpen && (
                  <div className="w-full px-4 max-w-[400px]">
                    <motion.div
                      className="w-full flex flex-col items-center justify-center mt-6 mb-4"
                      initial={{ opacity: 0, y: 40 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.7, ease: "easeOut" }}
                    >
                      {(review?.listing?.filter((e) => !e.reviewGiven) || [])
                        ?.length > 0 &&
                      review?.overAllRating !== 0 &&
                      reviewFlow?.reviewsEnabled &&
                      review?.overAllRating >
                        reviewFlow?.startLimitForReviewLink ? (
                        <>
                          <div className="relative w-full flex flex-col justify-center items-center gap-2 mb-3">
                            {review?.listing?.map(
                              (lst) =>
                                !lst?.reviewGiven && (
                                  <button
                                    key={lst.network}
                                    onClick={() =>
                                      handleSubmiListingReview(lst)
                                    }
                                    className="w-full inline-flex items-center justify-center gap-x-1 rounded-md bg-indigo-600 px-3 sm:px-3.5 py-2 sm:py-2.5 text-center text-xs sm:text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-colors whitespace-nowrap"
                                    aria-label={`Review on ${lst.network}`}
                                    disabled={ratingLoading}
                                  >
                                    <div className="flex-grow">
                                      {" "}
                                      Review us on{" "}
                                      {lst.network.charAt(0).toUpperCase() +
                                        lst.network.slice(1)}
                                      {""}
                                    </div>
                                    <div>
                                      <img
                                        src={
                                          lst?.network === "google"
                                            ? google
                                            : lst?.network === "tripadvisor"
                                              ? tripadvisor
                                              : lst?.network === "booking"
                                                ? booking
                                                : lst?.network === "agoda"
                                                  ? agoda
                                                  : lst?.network === "expedia"
                                                    ? expedia
                                                    : lst?.network === "yelp"
                                                      ? yelp
                                                      : lst?.network ===
                                                          "onelyk"
                                                        ? onelyk
                                                        : null
                                        }
                                        alt={`${lst.network} icon`}
                                        className="rounded-full  p-0 bg-white "
                                        style={{
                                          height: "24px",
                                          width: "24px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </div>
                                  </button>
                                ),
                            )}
                          </div>
                        </>
                      ) : null}
                    </motion.div>
                  </div>
                )}
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyModal;
